export const MENU_CALLOUT_PREFIX = "MENU_ITEMS_CALLOUT";

export const MENU_ITEMS_CALLOUT_TEST_IDS = {
    MENU_ITEMS_CALLOUT_WIDGET: `${MENU_CALLOUT_PREFIX}_WIDGET`,
    MENU_ITEMS_CALLOUT_MESSAGE: `${MENU_CALLOUT_PREFIX}_MESSAGE`,
    MENU_ITEMS_CALLOUT_HALF_CARD_TRIGGER: `${MENU_CALLOUT_PREFIX}_HALF_CARD_TRIGGER`,
    MENU_ITEMS_CALLOUT_HALF_CARD_WIDGET: `${MENU_CALLOUT_PREFIX}_HALF_CARD_WIDGET`,
    MENU_ITEMS_CALLOUT_HALF_CARD_IMAGE: `${MENU_CALLOUT_PREFIX}_HALF_CARD_IMAGE`,
    MENU_ITEMS_CALLOUT_HALF_CARD_TITLE: `${MENU_CALLOUT_PREFIX}_HALF_CARD_TITLE`,
    MENU_ITEMS_CALLOUT_HALF_CARD_DESCRIPTION: `${MENU_CALLOUT_PREFIX}_HALF_CARD_DESCRIPTION`,
};
